module.exports = __webpack_public_path__ + "static/global-warming-f2c03f9bdec83a9ba18e669008c759f1.jpg";